import CustomerAddress from "./CustomerAddress";
import CardLayout from "../../../layouts/CardLayout";
import Button from "../../../ui/Button";
import { AddIcon } from "../../../utils/icon.utils";
import { arrayMap } from "../../../utils/array.utils";

export default function CustomerAddressContainer({ data, onEdit, onAdd }) {
  const dataLength = data?.length;
  return (
    <CardLayout>
      <p>Address - {dataLength}</p>

      {arrayMap(data, (item, index) => (
        <CustomerAddress key={index} data={item} onEdit={onEdit} />
      )) || <p>No Address</p>}

      {dataLength < 1 && (
        <div className="text-end mt-3">
          <Button onClick={onAdd} name="Add" icon={AddIcon} />
        </div>
      )}
    </CardLayout>
  );
}
